import { tWithKeyAttr as t } from "../../i18nHelper";
import React, { useState } from "react";
import styles from "./clinicRecommendations.module.css";

type Props = {
  categories?: { [key: string]: number };
};

export default function ClinicRecommendations({ categories }: Props) {
  const [activeTab, setActiveTab] = useState<"ai" | "manual">("manual");

  const backgroundColors = ["#e6f0ff", "#e6fff3", "#f7eaff", "#fff4e6"];
  const badgeColors = ["#3b82f6", "#10b981", "#8b5cf6", "#f97316"];

  return (
    <div className={styles.clinicRecommendations__container}>
      <div className={styles.clinicRecommendations__header}>
        <button
          className={`${styles.clinicRecommendations__tabButton} ${activeTab === "manual" ? styles.clinicRecommendations__active : ""
            }`}
          onClick={() => setActiveTab("manual")}
        >
          {t('THERAPIST_RECOMMENDATIONS')}</button>
        <button
          className={`${styles.clinicRecommendations__tabButton} ${activeTab === "ai" ? styles.clinicRecommendations__active : ""
            }`}
          onClick={() => setActiveTab("ai")}
        >
          {t('AI_RECOMMENDATIONS')}</button>
      </div>

      <div className={styles.clinicRecommendations__grid}>


        {categories && Object.entries(categories).map(([label, value], entryIdx) => {
          const bgColor = backgroundColors[entryIdx % backgroundColors.length];
          const badgeColor = badgeColors[entryIdx % badgeColors.length];
          return (
            <div
              key={`${entryIdx}-${label}`}
              className={styles.clinicRecommendations__card}
              style={{ backgroundColor: bgColor }}
            >
              <div
                className={styles.clinicRecommendations__badge}
                style={{ backgroundColor: badgeColor }}
              >
                {value}
              </div>
              <div className={styles.clinicRecommendations__label}>
                {label}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
}
